module.exports = __webpack_public_path__ + "img/2048px-Instagram_icon.b84eb781.png";